$(() => {
  const init_megamenu = () => {
    $('[id^="HeaderMenu-MenuList"]').each((k, v) => {
      const $el = $(v);

      const parent_top = $el.parent().offset().top;
      const header_bottom = $el.closest('header').offset().top + $el.closest('header').outerHeight();

      $el.css({
        '--megamenu-top': Math.floor(header_bottom - parent_top) + 'px',
        '--megamenu-left': $el.parent().offset().left * -1 + 'px',
      });
    });
  };

  $(window).on('resize', init_megamenu).trigger('resize');
});

$(() => {
  const swiper_config = {
    a11y: false,
    slidesPerView: 'auto',
    spaceBetween: 0,
    //cssMode: true,
    navigation: {
      enabled: true,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      navigationDisabledClass: 'swiper-navigation-disabled',
      nextEl: document.querySelector('.button-next'),
      prevEl: document.querySelector('.button-prev'),
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    mousewheel: {
      enabled: true,
    },
  };

  // Featured Blogs Slider
  new Swiper('.featured-blog-slider .swiper-container', {
    ...swiper_config,
    ...{
      navigation: {
        ...swiper_config.navigation,
        ...{
          nextEl: document.querySelector('.featured-blog-slider .button-next'),
          prevEl: document.querySelector('.featured-blog-slider .button-prev'),
        },
      },
      scrollbar: {
        ...swiper_config.scrollbar,
        ...{
          el: '.featured-blog-slider .swiper-scrollbar',
        },
      },
    },
  });

  // Collection Filter Slider
  new Swiper('.collection-header--filter .swiper-container', {
    ...swiper_config,
    ...{
      navigation: {
        ...swiper_config.navigation,
        ...{
          nextEl: document.querySelector('.collection-header--filter .button-next'),
          prevEl: document.querySelector('.collection-header--filter .button-prev'),
        },
      },
      scrollbar: {
        ...swiper_config.scrollbar,
        ...{
          el: '.collection-header--filter .swiper-scrollbar',
        },
      },
    },
  });

  // Collection Filter Slider
  new Swiper('.collection-header--filter-2 .swiper-container', {
    ...swiper_config,
    ...{
      navigation: {
        ...swiper_config.navigation,
        ...{
          nextEl: document.querySelector('.collection-header--filter-2 .button-next'),
          prevEl: document.querySelector('.collection-header--filter-2 .button-prev'),
        },
      },
      scrollbar: {
        ...swiper_config.scrollbar,
        ...{
          el: '.collection-header--filter-2 .swiper-scrollbar',
        },
      },
    },
  });

  // Initialize Swiper when product recommendations are loaded
  $(document).on('product-recommendations:loaded', function (e) {
    document.querySelectorAll('.related-products-slider').forEach((slider) => {
      const container = slider.querySelector('.swiper-container');
      if (container && !container.swiper) {
        new Swiper(container, {
          ...swiper_config,
          ...{
            navigation: {
              ...swiper_config.navigation,
              ...{
                nextEl: slider.parentElement.querySelector('.button-next'),
                prevEl: slider.parentElement.querySelector('.button-prev'),
              },
            },
            scrollbar: {
              ...swiper_config.scrollbar,
              ...{
                el: slider.parentElement.querySelector('.swiper-scrollbar'),
              },
            },
          },
        });
      }
    });
  });

  // GENERIC SWIPER
  document.querySelectorAll('.swiper-slider').forEach((slider) => {
    const configScript = slider.querySelector('script[type="application/json"]');
    let customConfig = {};

    if (configScript) {
      try {
        customConfig = JSON.parse(configScript.textContent);
      } catch (e) {
        console.error('Invalid JSON in swiper slider script', e);
      }
    }

    const target_slider = new Swiper(slider.querySelector('.swiper-container'), {
      ...swiper_config,
      ...customConfig,
      ...{
        navigation: {
          ...swiper_config.navigation,
          ...customConfig.navigation,
          ...{
            nextEl: slider.querySelector('.button-next'),
            prevEl: slider.querySelector('.button-prev'),
          },
        },
        scrollbar: {
          ...swiper_config.scrollbar,
          ...customConfig.scrollbar,
          ...{
            el: slider.querySelector('.swiper-scrollbar'),
          },
        },
      },
    });

    slider.querySelectorAll('[data-swiper-nav-index]').forEach((nav) => {
      nav.addEventListener('click', (e) => {
        target_slider.slideTo(nav.dataset.swiperNavIndex);
      });
    });
  });
});
